import { createDescriptionTextNode } from "../utils/accessibility";

// modifies uibTooltip, to make it also add aria attributes automagically
function uibTooltip() {
	return {
		link: function(scope, element, attrs) {
			const trigger = element[0];
			if(!attrs.ariaLabel) {
				const description = createDescriptionTextNode(attrs.uibTooltip);
				trigger.parentNode.insertBefore(description, trigger);
				trigger.setAttribute("aria-describedby", description.id);
			}

		}
	};
}
export default angular
	.module("vesl.behaviors.uib-tooltip", [])
	.directive("uibTooltip", uibTooltip).name;
